import { useQuery } from "@tanstack/react-query";
import { request, gql } from "graphql-request";
import moment from "moment";

const totalF = 26;
const totalM = 25;
const chartInterval = 6;

const endpoint = "https://hub.snapshot.org/graphql/";

const QUERY_VOTES_F = gql`
	{
		votes(
			first: 1000
			where: {
				proposal: "0x89acaf3024d46c194206572277721d4905233a6c730871a8acd07dfcc9c64a88"
			}
		) {
			id
			voter
			created
			choice
			vp
		}
	}
`;

const QUERY_VOTES_M = gql`
	{
		votes(
			first: 1000
			where: {
				proposal: "0xb752b731ed6d9e7f0e382392055982476a8fd3d9fe159049eb3ffd8be09f746b"
			}
		) {
			id
			voter
			created
			choice
			vp
		}
	}
`;

const sortVotes = (left, right) => {
	if (left.totalVotesWithVP > right.totalVotesWithVP) {
		return -1;
	} else if (left.totalVotesWithVP < right.totalVotesWithVP) {
		return 1;
	} else {
		if (left.totalVotes > right.totalVotes) {
			return -1;
		} else if (left.totalVotes < right.totalVotes) {
			return 1;
		} else {
			return left.id < right.id ? -1 : 1;
		}
	}
};

export const useQueryVoteResultFromSnapshot = ({ listOption, sortEnabled }) => {
	const queryFn = async () => {
		const result = [];

		// ---- trends
		const trendsTimeGroups = [];

		const first = moment("2022-08-05T12:00:00");
		const final = moment("2022-08-08T00:00:00");

		let trendsGroupTime = moment(first);

		while (trendsGroupTime.isBefore(final)) {
			const items = [];
			for (var i = 0; i < (listOption === "f" ? totalF : totalM); i++) {
				items.push({
					id: listOption === "f" ? i : i + totalF,
					totalVotes: 0,
					totalVotesWithVP: 0,
					votes: [],
					rank: null,
				});
			}
			trendsTimeGroups.push({
				time: moment(trendsGroupTime),
				items: items,
			});
			trendsGroupTime = moment(trendsGroupTime).add(chartInterval, "hour");
		}
		// -----

		for (var j = 0; j < (listOption === "f" ? totalF : totalM); j++) {
			result.push({
				id: listOption === "f" ? j : j + totalF,
				totalVotes: 0,
				totalVotesWithVP: 0,
				votes: [],
				rank: null,
				trends: [],
			});
		}

		const data = await request(
			endpoint,
			listOption === "f" ? QUERY_VOTES_F : QUERY_VOTES_M
		);
		const votes = data.votes;
		if (votes) {
			votes.forEach((vote) => {
				vote.choice?.forEach((choice, choiceIndex) => {
					if (vote.vp > 0) {
						result[choice - 1].totalVotes += 1;
						result[choice - 1].totalVotesWithVP += 1 * vote.vp;
						result[choice - 1].votes.push(vote);

						trendsTimeGroups.forEach((group, index) => {
							if (vote.created <= group.time.unix()) {
								trendsTimeGroups[index].items[choice - 1].totalVotes += 1;
								trendsTimeGroups[index].items[choice - 1].totalVotesWithVP +=
									1 * vote.vp;
								trendsTimeGroups[index].items[choice - 1].votes.push(vote);
							}
						});
					}
				});
			});
		}

		// ---- Sort Votes in Trends Groups
		trendsTimeGroups.forEach((group, index) => {
			trendsTimeGroups[index].sortedItems = [
				...trendsTimeGroups[index].items,
			].sort(sortVotes);

			trendsTimeGroups[index].items.forEach((choice, choiceIndex) => {
				trendsTimeGroups[index].items[choiceIndex].rank =
					trendsTimeGroups[index].sortedItems.findIndex(
						(item) => item.id === choice.id
					) + 1;
			});
		});

		// ---- Sort Total Votes
		const sortedResult = [...result].sort(sortVotes);

		result.forEach((choice, index) => {
			result[index].rank =
				sortedResult.findIndex((item) => item.id === choice.id) + 1;

			result[index].trends = trendsTimeGroups.map((group) => {
				return {
					x: moment(group.time).format("DD MMM HH:mm"),
					y: group.sortedItems.findIndex((item) => item.id === choice.id) + 1,
				};
			});

			result[index].trends.push({
				x: moment(final).format("DD MMM HH:mm"),
				y: result[index].rank,
			});
		});

		return {
			records: sortEnabled
				? [
						...result.sort((left, right) => {
							return left.rank < right.rank ? -1 : 1;
						}),
				  ]
				: result,
			trendsTimeGroups,
			lastRefreshTime: moment(),
		};
	};

	return useQuery(
		["voteResultFromSnapshot", { listOption, sortEnabled }],
		queryFn
	);
};
